import * as React from 'react';
import {
	Button,
	Label,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
} from 'reactstrap';
import InputField from '@_common/InputRuleFeild';
import { getValue } from '@utils/lodash';
import '../popup/addpopup.scss';

interface IChoicePopupProps {
	isOpen: boolean;
	handleModal: () => void;
	handleSubmit: () => void;
	text: string;
	setText: any;
	handleModalCancel: () => void;
}

const ChoicePopup: React.FunctionComponent<IChoicePopupProps> = (props) => {
	return (
		<Modal
			isOpen={getValue(props, `isOpen`, '')}
			toggle={getValue(props, `isOpen`, '')}
			className="choice-popup"
			centered
		>
			<section className="choice-popup-wrapper">
				<div className="choice-popup-wrapper__popup">
					<div className="add-popup-wrapper__form-group form-group">
						<Label>Category Name * </Label>
						<InputField
							inputType="TEXT"
							placeholder="Enter Category Name"
							name={'text'}
							value={props.text}
							id={'text'}
							onChange={(e: any) => props.setText(e.target.value)}
						/>
					</div>
					<div className="add-popup-wrapper__cta-wrapper">
						<button
							onClick={props.handleModalCancel}
							className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--secondary"
						>
							Cancel
						</button>
						<button
							className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--primary"
							onClick={props.handleSubmit}
						>
							Save
						</button>
					</div>
				</div>
			</section>
		</Modal>
	);
};

export default ChoicePopup;
